/**
 * Account management translations
 * Includes: Set password, account cancellation
 */
export default {
  accountManagement: 'Account management',
  setPassword: 'Set Password',
  accountCancellation: 'Account Cancellation',
  enterNewPassword: 'Enter a new password',
  enterNewPasswordAgain: 'Enter the new password again',
  passwordRequirements: 'The password must be 8-16 characters in length and contain both English letters and numbers',
  save: 'Save',
  accountToBeCanceled: 'Account to be canceled',
  pleaseNote: 'Please note that once the account is canceled:',
  cancelNote1: '1. You will never be able to sign in and use the account;',
  cancelNote2: '2. Any virtual assets within the account, such as account diamonds, gifts, portrait frames, and entrance banners, will be emptied;',
  cancelNote3: '3. All account information, including your profile and portrait, will be cleared;',
  cancelNote4: '4. Your friends list, call logs, and chat history will be cleared.',
  confirmAndContinue: 'Confirm and Continue',
  passwordMismatch: 'The two passwords do not match',
  passwordFormatError: 'Password must be 8-16 characters and contain both letters and numbers',
  setPasswordSuccess: 'Password set successfully',
  cancelAccountSuccess: 'Account cancellation request submitted',
}
